"use client";

import Footer from '@/components/Footer'
import Header from '@/components/Header'
import React from 'react'

export default function page() {
    return (
        <>
            <Header />
            <main className='min-h-screen'>

            </main>
            <Footer />
        </>
    )
}
